export const MuiDialogTitle = {
  styleOverrides: {
    root: {
      padding: '24px 24px 8px 24px',
      lineHeight: 1,
    },
  },
};
